import store from './store';
import {
  UPDATE_LOADING_STATUS,
  UPDATE_IMM_LOADING_STATUS,
  UPDATE_AOP_LOADING_STATUS,
} from '../constants';

let timerLoading = null;
let timerLoaded = null;
let queue = [];
const latencyThreshold = 600;

export const loading = (ignore) => {
  store.commit(UPDATE_AOP_LOADING_STATUS, true);
  if (!ignore) {
    queue.push({});
    store.commit(UPDATE_IMM_LOADING_STATUS, true);
    if (queue.length == 1) {
      timerLoading = setTimeout(() => {
        if (queue.length) {
          store.commit(UPDATE_LOADING_STATUS, true);
          if (timerLoading) clearTimeout(timerLoading);
        }
      }, latencyThreshold);
    }
  }
};

export const loaded = () => {
  store.commit(UPDATE_AOP_LOADING_STATUS, false);
  queue.pop();
  if (queue.length == 0) {
    timerLoaded = setTimeout(() => {
      if (queue.length == 0 && (store.state.loading || store.state.immLoading)) {
        store.commit(UPDATE_LOADING_STATUS, false);
        store.commit(UPDATE_IMM_LOADING_STATUS, false);
        if (timerLoaded) clearTimeout(timerLoaded);
      }
    }, latencyThreshold);
  }
};
